import { create } from 'zustand'
import { clearAuthToken } from '../auth'
import { createModalStore } from '../global'
import { User, UserRole, UserWorkspaceRole } from './user.type'

export const useChangePasswordModalStore = createModalStore()

export const useAddMemberModalStore = createModalStore()

export const useEditMemberModalStore = createModalStore()

export interface UserState {
  currentUser: Partial<User> | null

  currentRole: UserRole | null
  currentPermissions?: UserWorkspaceRole | null

  isAdmin: boolean
  isQASenior: boolean
  isQAMember: boolean

  selectedWorkspace?: string
  selectedCxGenieWorkspace?: string

  setIsAdmin: (isAdmin: boolean) => void
  setIsQASenior: (isQASenior: boolean) => void
  setIsQAMember: (isQAMember: boolean) => void

  setCurrentUser: (user: Partial<User>) => void
  setCurrentRole: (role: UserRole | null) => void
  setCurrentPermissions: (permissions?: UserWorkspaceRole | null) => void

  setSelectedWorkspace?: (wp?: string) => void
  setSelectedCxGenieWorkspace?: (wp?: string) => void
  logout: () => void
}

export const useUserStore = create<UserState>((set) => ({
  currentUser: null,

  currentRole: null,
  currentPermissions: null,
  isAdmin: false,
  isQASenior: false,
  isQAMember: false,
  selectedWorkspace: '',
  selectedCxGenieWorkspace: '',

  setIsAdmin: (isAdmin) => set({ isAdmin }),
  setIsQASenior: (isQASenior) => set({ isQASenior }),
  setIsQAMember: (isQAMember) => set({ isQAMember }),

  setCurrentUser: (currentUser) => set({ currentUser }),
  setCurrentRole: (currentRole) => set({ currentRole }),
  setCurrentPermissions: (currentPermissions) => set({ currentPermissions }),

  setSelectedWorkspace: (wp) => set({ selectedWorkspace: wp }),
  setSelectedCxGenieWorkspace: (wp) => set({ selectedCxGenieWorkspace: wp }),

  logout: () => {
    set({
      currentUser: null,
      currentRole: null,
      currentPermissions: null,
      isAdmin: false,
      isQASenior: false,
      isQAMember: false,
      selectedWorkspace: '',
      selectedCxGenieWorkspace: '',
    })
    clearAuthToken()
  },
}))

export interface MemberPermissionsDrawerState {
  user: User | null
  setUser: (user: User) => void
  reset: () => void
}

export const useMemberPermissionsDrawerStore = create<MemberPermissionsDrawerState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  reset: () => set({ user: null }),
}))
